import { Component, OnInit, ViewChild } from "@angular/core";
import { ColaboradoresService } from "../../../services/colaboradores-service";
import { MdDialogRef } from "@angular/material";
import { RolesAutocompleteComponent } from "../../../components/common/autocomplete";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  HttpClient,
  PermisosService,
  PERM_ACCIONES_ID,
} from "../../../services";
import { of } from "rxjs/observable/of";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import { MdSnackBar } from "@angular/material";

// validador de userName, usamos una funcion que devuelve la funcion validadora
const validateUserNameExists: any =
  (client: HttpClient, currentUsername: string) => (control: FormControl) => {
    // si estamos validando el username actual, no hay cambios, devolvemos null sin importar el case
    if (
      control.value.toString().toLowerCase() === currentUsername.toLowerCase()
    ) {
      return of(null);
    }
    // vamos al back y retornamos el observable, no nos suscribimos, angular se encarga de ello
    // usamos el timer para simular un debounce time
    return Observable.timer(500).switchMap(() => {
      return client
        .post("/api/user/check-username", {
          UserName: control.value.toString(),
        })
        .map((res: Response) => {
          if (res) {
            // si recibimos true, implica que hay un username existente, devolvemos el error
            return res.json().ResponseData
              ? { duplicatedUserName: true }
              : null;
          }
        });
    });
  };

@Component({
  selector: "app-new-colaborador-dialog",
  templateUrl: "./new-colaborador-dialog.component.html",
  styleUrls: ["./new-colaborador-dialog.component.scss"],
})
export class NewColaboradorDialogComponent implements OnInit {
  public title: string;
  public positiveText: string;
  public negativeText: string;
  public roles: any[];
  public isEdit: boolean;
  public colaborador: any;
  formGroup: FormGroup = null;
  @ViewChild(RolesAutocompleteComponent) rolesAutocompleteComponent;
  maxLengths = {
    default: 60,
    email: 250,
  };

  constructor(
    private colaboradoresService: ColaboradoresService,
    public dialogRef: MdDialogRef<NewColaboradorDialogComponent>,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private permisosService: PermisosService,
    private snackBar: MdSnackBar
  ) {}

  ngOnInit() {
    let usernameEditAllowed = true;
    if (this.colaborador) {
      this.isEdit = true;
      usernameEditAllowed = this.permisosService.permisoAutorizado(
        PERM_ACCIONES_ID.A_EditarNomUsuario
      );
      this.roles = this.colaborador.Roles.map((r) => r.Id);
    }

    this.formGroup = this.fb.group({
      name: [
        this.isEdit
          ? this.colaborador.UserFullName.substring(
              0,
              this.colaborador.UserFullName.indexOf(" ")
            ).trim()
          : "",
        [Validators.required, Validators.maxLength(this.maxLengths.default)],
      ],
      lastName: [
        this.isEdit
          ? this.colaborador.UserFullName.substring(
              this.colaborador.UserFullName.indexOf(" ") + 1
            ).trim()
          : "",
        [Validators.required, Validators.maxLength(this.maxLengths.default)],
      ],
      username: this.fb.control(
        {
          value: this.isEdit ? this.colaborador.UserName : "",
          disabled: !usernameEditAllowed,
        },
        [
          Validators.required,
          Validators.maxLength(this.maxLengths.default),
          Validators.minLength(3),
        ],
        [
          validateUserNameExists(
            this.httpClient,
            this.isEdit ? this.colaborador.UserName : ""
          ),
        ]
      ),
      email: [
        this.isEdit ? this.colaborador.Email : "",
        [
          Validators.required,
          Validators.pattern(
            /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/
          ),
        ],
      ],
      phoneNumber: [
        this.isEdit ? this.colaborador.Telefono : "",
        [Validators.pattern(new RegExp("^[0-9]+$"))],
      ],
      domicilio: [
        this.isEdit ? this.colaborador.Domicilio : "",
        Validators.maxLength(this.maxLengths.default),
      ],
      jde: [
        this.isEdit
          ? this.colaborador.UserNameJDE || this.colaborador.User_JDE
          : "",
        Validators.maxLength(this.maxLengths.default),
      ],
      saf: [
        this.isEdit ? this.colaborador.User_SAF : "",
        Validators.maxLength(this.maxLengths.default),
      ],
      cupos: [
        this.isEdit ? this.colaborador.Usu_Usuario_Cupos : "",
        Validators.maxLength(this.maxLengths.default),
      ],
    });

    // hacemos esto para que al realizar cambios muestre cualquier error sin necesidad de hacer blur al campo
    if (this.isEdit) {
      Object.keys(this.formGroup.controls).forEach((key: string) => {
        const abstractControl = this.formGroup.controls[key];
        abstractControl.markAsTouched();
      });
    }
  }

  onSubmit() {
    if (this.colaborador) {
      this.colaboradoresService
        .editColaborador(
          this.colaborador.UserId,
          this.nameCtrl.value,
          this.lastNameCtrl.value,
          this.usernameCtrl.value,
          this.jdeCtrl.value,
          this.safCtrl.value,
          this.cuposCtrl.value,
          this.rolesAutocompleteComponent.selectedRoles.map((r) => r.Id),
          this.emailCtrl.value,
          this.phoneNumberCtrl.value,
          this.domicilioCtrl.value
        )
        .subscribe(
          (data) => {
            this.dialogRef.close();
          },
          (err) => {
            this.toggleErrorMessage();
          }
        );
    } else {
      this.colaboradoresService
        .createColaborador(
          this.nameCtrl.value,
          this.lastNameCtrl.value,
          this.usernameCtrl.value,
          this.jdeCtrl.value,
          this.safCtrl.value,
          this.cuposCtrl.value,
          this.rolesAutocompleteComponent.selectedRoles.map((r) => r.Id),
          this.emailCtrl.value,
          this.phoneNumberCtrl.value,
          this.domicilioCtrl.value
        )
        .subscribe(
          (data) => {
            this.dialogRef.close();
          },
          (err) => {
            this.toggleErrorMessage();
          }
        );
    }
  }

  toggleErrorMessage() {
    this.snackBar.open(
      "Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.",
      "",
      {
        duration: 2000,
        extraClasses: ["agd-warning-snackbar"],
      }
    );
  }

  get nameCtrl(): AbstractControl {
    return this.formGroup.get("name");
  }

  get lastNameCtrl(): AbstractControl {
    return this.formGroup.get("lastName");
  }

  get usernameCtrl(): AbstractControl {
    return this.formGroup.get("username");
  }

  get jdeCtrl(): AbstractControl {
    return this.formGroup.get("jde");
  }

  get safCtrl(): AbstractControl {
    return this.formGroup.get("saf");
  }

  get cuposCtrl(): AbstractControl {
    return this.formGroup.get("cupos");
  }

  get emailCtrl(): AbstractControl {
    return this.formGroup.get("email");
  }

  get phoneNumberCtrl(): AbstractControl {
    return this.formGroup.get("phoneNumber");
  }

  get domicilioCtrl(): AbstractControl {
    return this.formGroup.get("domicilio");
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/new-colaborador-dialog/new-colaborador-dialog.component.ts